function preloadCollectionGridImage(img) {
  if (!img) {
    return Promise.resolve();
  }

  if (img.complete && img.naturalWidth > 0) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const preloadImage = new Image();

    preloadImage.onload = resolve;
    preloadImage.onerror = resolve;

    if (img.sizes) {
      preloadImage.sizes = img.sizes;
    }

    if (img.srcset) {
      preloadImage.srcset = img.srcset;
    }

    preloadImage.src = img.currentSrc || img.src;
  });
}

function preloadCollectionGridImages(container) {
  const images = Array.from(container.querySelectorAll('#product-grid img')).filter((img) => {
    return img.currentSrc || img.getAttribute('src') || img.getAttribute('srcset');
  });

  if (!images.length) {
    return Promise.resolve();
  }

  return Promise.all(images.map((img) => preloadCollectionGridImage(img)));
}

function shouldDelayCollectionGridRevealOnLoad(search = window.location.search) {
  const params = new URLSearchParams(search);
  const priceKeys = [
    'filter.unit_price.gte',
    'filter.unit_price.lte',
    'filter.v.price.gte',
    'filter.v.price.lte',
    'filter.p.price.gte',
    'filter.p.price.lte',
  ];

  const hasActivePriceFilter = priceKeys.some((key) => {
    const value = params.get(key);
    return typeof value === 'string' && value.trim() !== '';
  });

  if (hasActivePriceFilter) {
    return true;
  }

  const sortBy = (params.get('sort_by') || '').trim();
  return sortBy === 'price-ascending' || sortBy === 'price-descending';
}

function initializeCollectionGridReveal(container = document.getElementById('ProductGridContainer'), options = {}) {
  const { force = false } = options;

  if (!container) {
    return;
  }

  const collection = container.querySelector('.collection');

  if (!collection) {
    return;
  }

  if (!force && shouldDelayCollectionGridRevealOnLoad()) {
    collection.classList.add('loading', 'loading-images');
    return;
  }

  const revealToken = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  collection.dataset.gridRevealToken = revealToken;
  collection.classList.add('loading', 'loading-images');

  preloadCollectionGridImages(container).then(() => {
    requestAnimationFrame(() => {
      if (collection.dataset.gridRevealToken !== revealToken) {
        return;
      }

      collection.classList.remove('loading', 'loading-images');
    });
  });
}

window.initializeCollectionGridReveal = initializeCollectionGridReveal;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeCollectionGridReveal());
} else {
  initializeCollectionGridReveal();
}

document.addEventListener('shopify:section:load', () => initializeCollectionGridReveal());